// Spec 27 PR 2b — onboarding widget registrations (client side).
//
// Imported once at module load (apps/web/src/lib/onboarding-boot.ts).
// Adds AgentMessage / SuggestionChips / WorkspaceConfirm to the
// shared registry so WidgetSurface can render them by kind.

import { registerClientWidget } from "../registry";

import { AgentMessage } from "./agent-message";
import { FinalContinue } from "./final-continue";
import { MultiInputCard } from "./multi-input-card";
import { OAuthConnectCard } from "./oauth-connect-card";
import { ProgressCard } from "./progress-card";
import { RepoPickerCard } from "./repo-picker-card";
import { SuggestionChips } from "./suggestion-chips";
import { SummaryCard } from "./summary-card";
import { TextPrompt } from "./text-prompt";
import { WorkspaceConfirm } from "./workspace-confirm";

let registered = false;

export function registerOnboardingClientWidgets(): void {
	if (registered) return;
	registerClientWidget({
		kind: "agent_message",
		label: "Agent message",
		component: AgentMessage,
	});
	registerClientWidget({
		kind: "suggestion_chips",
		label: "Suggestion chips",
		component: SuggestionChips,
	});
	registerClientWidget({
		kind: "workspace_confirm",
		label: "Workspace confirm",
		component: WorkspaceConfirm,
	});
	registerClientWidget({
		kind: "multi_input_card",
		label: "Multi-input card",
		component: MultiInputCard,
	});
	registerClientWidget({
		kind: "oauth_connect_card",
		label: "OAuth connect card",
		component: OAuthConnectCard,
	});
	registerClientWidget({
		kind: "repo_picker_card",
		label: "Repo picker card",
		component: RepoPickerCard,
	});
	registerClientWidget({
		kind: "progress_card",
		label: "Progress card",
		component: ProgressCard,
	});
	registerClientWidget({
		kind: "summary_card",
		label: "Summary card",
		component: SummaryCard,
	});
	registerClientWidget({
		kind: "final_continue",
		label: "Final continue",
		component: FinalContinue,
	});
	registerClientWidget({
		kind: "text_prompt",
		label: "Text prompt",
		component: TextPrompt,
	});
	registered = true;
}
